import { Container, Title, Text, Stack } from '@mantine/core';
import { useTheme } from '../theme/theme';

export const PrivacyPage = () => {
  const theme = useTheme();

  return (
    <Container size='md' py='xl'>
      <Stack gap='lg'>
        <Title order={1}>Privacy Policy</Title>
        <Text c={theme.v0.col.textDimmed.hex} size='sm'>
          Last updated: {new Date().toLocaleDateString()}
        </Text>

        <div>
          <Title order={2} size='h3' mb='xs'>
            1. Introduction
          </Title>
          <Text>
            Epilogo SRL ("we", "our", or "us") operates the epilogo platform. This page informs you of our policies
            regarding the collection, use, and disclosure of personal data when you use our Service and the choices you
            have associated with that data.
          </Text>
        </div>

        <div>
          <Title order={2} size='h3' mb='xs'>
            2. Information Collection and Use
          </Title>
          <Text>
            We collect several different types of information for various purposes to provide and improve our Service to
            you.
          </Text>
        </div>

        <div>
          <Title order={2} size='h3' mb='xs'>
            3. Types of Data Collected
          </Title>
          <Text>
            Personal Data: While using our Service, we may ask you to provide us with certain personally identifiable
            information that can be used to contact or identify you ("Personal Data"). This may include, but is not
            limited to:
          </Text>
          <ul>
            <li>Email address</li>
            <li>First name and last name</li>
            <li>Phone number</li>
            <li>Address, State, Province, ZIP/Postal code, City</li>
            <li>Cookies and Usage Data</li>
          </ul>
        </div>

        <div>
          <Title order={2} size='h3' mb='xs'>
            4. Use of Data
          </Title>
          <Text>epilogo uses the collected data for various purposes:</Text>
          <ul>
            <li>To provide and maintain our Service</li>
            <li>To notify you about changes to our Service</li>
            <li>To allow you to participate in interactive features of our Service</li>
            <li>To provide customer support</li>
            <li>To gather analysis or valuable information</li>
            <li>To monitor the usage of our Service</li>
            <li>To detect, prevent and address technical issues</li>
          </ul>
        </div>

        <div>
          <Title order={2} size='h3' mb='xs'>
            5. Contact Us
          </Title>
          <Text>
            If you have any questions about this Privacy Policy, please contact us at privacy@epilogo.co
          </Text>
        </div>
      </Stack>
    </Container>
  );
};
